
import { waitFor } from "vue-wait";
import Employees from "~/components/Employees.vue";
//import relatedTreatments from "~/components/relatedTreatments.vue";
import EmployeesPerformingTreatment from "../../../components/EmployeesPerformingTreatment.vue";
import CrossSalonDialog from "../../../components/CrossSalonDialog.vue";
import ChooseSalonDialog from "@fixit/fixit-no-header/src/components/Common/CommonComponents/chooseSalonDialog.vue";
import FIcon from "@fixit/icons/src/components/FIcon.vue";
import CmsHomepageModuleEnum from "@/static/enums/modules/cmsHomepageModuleEnum";
import AddToCartBtn from "../../cart/components/AddToCartBtn.vue";
import AddToCart from "../../cart/components/AddToCart.vue";
import RecEngineModule from "../../../components/RecEngineModule.vue";
import { ItemType, Location } from "@fixit/v-recommendation-box/src/enums";
import { User } from "@fixit/fixit-no-header/src/models";

export default {
  layout: "HomepageLayout",
  components: {
    Employees,
    //relatedTreatments,
    EmployeesPerformingTreatment,
    ChooseSalonDialog,
    FIcon,
    AddToCartBtn,
    AddToCart,
    RecEngineModule,
    CrossSalonDialog,
  },
  name: "TreatmentItemPage",
  head() {
    let metaTagsTemplate = `%s | ${this.$store.getters["cmsConfigHomepage/getChainName"]}`;
    return {
      title: this.treatmentItem.metaTags.title,
      titleTemplate: metaTagsTemplate,
      meta: [
        {
          hid: "title",
          name: "title",
          template: metaTagsTemplate,
          content: this.treatmentItem.metaTags.title,
        },
        {
          hid: "description",
          name: "description",
          content: this.treatmentItem.metaTags.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.treatmentItem.metaTags.keywords,
        },
        {
          hid: "og:type",
          name: "og:type",
          content: this.treatmentItem.metaTags.ogType,
        },
        {
          hid: "og:url",
          name: "og:url",
          content: this.treatmentItem.metaTags.ogUrl,
        },
        {
          hid: "og:title",
          name: "og:title",
          template: metaTagsTemplate,
          content: this.treatmentItem.metaTags.ogTitle,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.treatmentItem.metaTags.ogDescription,
        },
      ],
    };
  },
  async asyncData(context) {
    let treatmentItem = await context.store.dispatch(
      "treatments/fetchTreatment",
      context.route.params.id
    );
    return {
      treatmentItem,
    };
  },
  data: () => ({
    isMounted: false,
    mainImage: null,
    fullscreen: false,
    treatment: null,
    //relatedTreatments: [],
    selectedSalon: null,
    addedKey: 0,
    querySiteId: null,
    itemType: ItemType,
    location: Location,
  }),
  async mounted() {
    this.isMounted = true;
    // if (
    //   this.treatmentItem.relatedTreatments != null &&
    //   this.treatmentItem.relatedTreatments != undefined &&
    //   this.treatmentItem.relatedTreatments.length
    // ) {
    //   this.treatmentItem.relatedTreatments.forEach(async (id) => {
    //     var relItem = await this.$store.dispatch(
    //       "treatments/fetchTreatment",
    //       id
    //     );
    //     if (relItem) this.relatedTreatments.push(relItem);
    //   });
    // }
  },
  computed: {
    user() {
      return new User(this.$store.getters["app/get"]("user"));
    },
    bookingActive() {
      return this.$store.getters['salon/bookingEnabledForSite'](this.selectedSalon && this.selectedSalon.siteId ? this.selectedSalon.siteId : this.selectedSalon)
    },
    chainId() {
      return this.$store.getters["cmsConfigHomepage/getChainId"];
    },
    siteIds() {
      return this.$store.getters["salon/getSiteIds"];
    },
    breadcrumbs() {
      return [
        { name: "Hjem", disabled: false, href: "/" },
        {
          name: "Behandlinger",
          disabled: false,
          href: `/behandlinger${
            this.querySiteId ? "?department=" + this.querySiteId : ""
          }`,
        },
        ...this.category && this.category.categoryName? [
          {
            name: this.category.categoryName,
            disabled: false,
            href: `/behandlinger?category=${
              this.category.treatmentCategoryId
            }&page=1${this.querySiteId ? "&department=" + this.querySiteId : ""}`,
          }
        ] : [],
        { name: this.treatment.treatmentName, disabled: true },
      ];
    },
    salonPhoneNumber() {
      if (
        (this.selectedSalon && this.selectedSalon.siteId) ||
        this.selectedSalon
      ) {
        return this.$store.getters["salon/getSalonPhoneNumber"](
          this.selectedSalon && this.selectedSalon.siteId
            ? this.selectedSalon.siteId
            : this.selectedSalon
        ).phone;
      } else return null;
    },
    chainAppointmentButtonOverrideUrl() {
      return this.$store.getters[
        "cmsConfigHomepage/getAppointmentButtonOverrideUrl"
      ];
    },
    chainAppointmentButtonOverrideText() {
      return this.$store.getters[
        "cmsConfigHomepage/getAppointmentButtonOverrideText"
      ];
    },
    userIsLoggedIn() {
      return this.$store.getters["app/get"]("user").onlineSluttKundeId != 0;
    },
    isFavoriteTreatment() {
      return (
        this.$store.getters["treatments/getFavoriteTreatments"].find(
          (x) => x.treatmentId == this.treatment.treatmentId
        ) != null
      );
    },
    category() {
      return this.$store.getters["treatments/getTreatmentCategoryList"].find((el) => el.treatmentCategoryId == this.treatment.categoryId) ?? null
    },
    priceText() {
      return this.treatment.pricePerSite.length ? "Fra " : "Kr ";
    },
    minPrice() {
      return Math.min(...this.treatment.pricePerSite.map((p) => p.price));
    },
    bigImage() {
      return this.treatment.ftcCategoryImgUrls[this.mainImage];
    },
    bigImages() {
      return this.treatment.ftcCategoryImgUrls;
    },
    images() {
      return this.treatment.ftcCategoryImgUrlsThumbnails &&
        this.treatment.ftcCategoryImgUrlsThumbnails.length
        ? this.treatment.ftcCategoryImgUrlsThumbnails
        : [
            "https://res.cloudinary.com/odin-systemer-test/image/upload/v1665556556/defaults/default-treatment.svg",
          ];
    },
    salonsPerformingTreatment() {
      let salons = this.$store.getters["salon/getSalons"];
      let sites = [];
      let siteIds = salons.map((s) => s.siteId);
      siteIds.forEach((siteId) => {
        if (this.treatment) {
          this.treatment.pricePerSite.forEach((priceSite) => {
            if (priceSite.siteId == siteId)
              sites.push(salons.find((s) => s.siteId == siteId));
          });
        } else {
          sites.push(salons.find((s) => s.siteId == siteId));
        }
      });

      if (sites.length == 1) this.selectedSalon = sites[0];
      return sites;
    },
    isDraft() {
      return this.$store.getters["cmsConfigHomepage/isDraftMode"];
    },
    showPrice() {
      var modules = this.$store.getters["cmsConfigHomepage/getModules"];
      let moduleShowPricesValue = modules.find(
        (m) => m.moduleId == CmsHomepageModuleEnum.PRICES
      )?.visible;
      let prices = true;
      if (moduleShowPricesValue != undefined && moduleShowPricesValue != null)
        prices = moduleShowPricesValue;
      return prices;
    },
    selectedSalonPrice() {
      let siteId = this.selectedSalon.siteId || this.selectedSalon;
      return this.treatment.pricePerSite.find((doc) => doc.siteId == siteId)
        .price;
    },
  },
  methods: {
    treatmentTime() {
      if (this.treatmentItem.durationMinutes > 60) {
        var hours = Math.floor(this.treatmentItem.durationMinutes / 60);
        var minutes = this.treatmentItem.durationMinutes % 60;
        return hours + " t " + minutes + " min";
      }
      return this.treatmentItem.durationMinutes + " min";
    },
    keepSalonChoice() {
      this.setCurrentSalon();
    },
    async addOrRemove() {
      this.$store.commit("cart/setSelectedSalon", this.selectedSalon.siteId || this.selectedSalon);

      this.addedKey += 1;
    },
    treatmentIsInCart(treatment) {
      return this.$store.getters["cart/treatmentIsInCart"](
        treatment.treatmentId
      );
    },
    treatmentRedirect(item) {
      this.$router.push(`/Behandlinger/${item.urlSafe}`);
    },
    formatDescription(text) {
      if (typeof String.prototype.replaceAll == "undefined") {
        String.prototype.replaceAll = function (match, replace) {
          return this.replace(new RegExp(match, "g"), () => replace);
        };
      }
      return text.replaceAll("\n", "</br>");
    },
    async saveOrRemoveTreatment(treatment) {
      if (this.userIsLoggedIn) {
        var result = await this.$store.dispatch(
          "treatments/updateFavoriteTreatments",
          treatment
        );
        if (result) {
          await this.$store.dispatch("treatments/fetchFavoriteTreatments");
        }
      }
    },
    redirect(site) {
      if (this.chainAppointmentButtonOverrideUrl != null) {
        if (this.chainAppointmentButtonOverrideUrl != "") {
          window.open(this.chainAppointmentButtonOverrideUrl, "_self");
        }
      } else if (this.selectedSalon.appointmentButtonOverrideUrl != null) {
        if (this.selectedSalon.appointmentButtonOverrideUrl != "") {
          window.open(this.selectedSalon.appointmentButtonOverrideUrl, "_self");
        }
      } else {
        this.$router.push("/behandlinger");
      }
    },
    setCurrentSalon() {
      if (this.salonsPerformingTreatment.length > 1) {
        let selected = this.$store.getters["cart/getSelectedSalon"];
        if (selected) {
          this.selectedSalon =
            this.salonsPerformingTreatment.find((x) => x.siteId === selected) ||
            null;
        } else {
          var siteId = +this.$route.query.department;
          if (siteId) {
            this.querySiteId = siteId;
            this.selectedSalon = this.salonsPerformingTreatment.find(
              (x) => x.siteId === siteId
            );
          }
        }
      }
    },
  },
  beforeCreate() {
    waitFor(`loading treatments ${this.$route.params.id}`, async function () {
      this.treatment = await this.$store.dispatch(
        "treatments/fetchTreatment",
        this.$route.params.id
      );
      this.setCurrentSalon();
    }).apply(this);
  },
  watch: {
    selectedSalon() {
      this.addedKey = 0;
      this.$store.commit(
        "cart/setSelectedSalon",
        this.selectedSalon.siteId || this.selectedSalon
      );
      waitFor(`refresh employees`, async function () {
        const cart = this.$store.getters['cart/getCart'];
        if (cart && cart.siteId && cart.siteId !== (this.selectedSalon.siteId || this.selectedSalon) && cart.treatmentIds.length) {
          this.$store.commit('cart/setShowCrossSiteDialog', true)
        }
      }).apply(this);
    },
  },
};
